module.exports = __webpack_public_path__ + "77dc66e0fb42ca4290264d28f01a54f0.woff";